/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApplicationFormDto,
  ApplicationFormStatus,
  FormElementDto,
  MigrateApplicationForm409Response,
  MigrateRequestDto,
  MigrationPreviewDto,
  MigrationStatusDto,
  PagedApplicationFormDto,
  ProblemDetails,
} from '../models/index';
import {
    ApplicationFormDtoFromJSON,
    ApplicationFormDtoToJSON,
    ApplicationFormStatusFromJSON,
    ApplicationFormStatusToJSON,
    FormElementDtoFromJSON,
    FormElementDtoToJSON,
    MigrateApplicationForm409ResponseFromJSON,
    MigrateApplicationForm409ResponseToJSON,
    MigrateRequestDtoFromJSON,
    MigrateRequestDtoToJSON,
    MigrationPreviewDtoFromJSON,
    MigrationPreviewDtoToJSON,
    MigrationStatusDtoFromJSON,
    MigrationStatusDtoToJSON,
    PagedApplicationFormDtoFromJSON,
    PagedApplicationFormDtoToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface AddFormElementToSubSectionRequest {
    applicationFormId: string;
    subsectionId: string;
    position: number;
    formElementDto: FormElementDto;
}

export interface ArchiveApplicationFormRequest {
    id: string;
}

export interface AssignSignersRequest {
    id: string;
}

export interface CreateApplicationFormRequest {
    applicationFormDto: Omit<ApplicationFormDto, 'commentCount'|'latestVersionNumber'|'reviewNotificationSent'|'sourceTemplateVersion'>;
}

export interface DeleteApplicationFormRequest {
    id: string;
}

export interface GetAllApplicationFormsRequest {
    organizationId?: string;
    page?: number;
    size?: number;
    sortBy?: GetAllApplicationFormsSortByEnum;
    sortDirection?: GetAllApplicationFormsSortDirectionEnum;
    search?: string;
    status?: ApplicationFormStatus;
    createdByCurrentUser?: boolean;
}

export interface GetApplicationFormByIdRequest {
    id: string;
}

export interface GetApplicationFormMigrationPreviewRequest {
    id: string;
}

export interface GetApplicationFormMigrationStatusRequest {
    id: string;
}

export interface MigrateApplicationFormRequest {
    id: string;
    migrateRequestDto: MigrateRequestDto;
}

export interface SubmitApplicationFormRequest {
    id: string;
}

export interface UnarchiveApplicationFormRequest {
    id: string;
}

export interface UpdateApplicationFormRequest {
    id: string;
    applicationFormDto: Omit<ApplicationFormDto, 'commentCount'|'latestVersionNumber'|'reviewNotificationSent'|'sourceTemplateVersion'>;
}

/**
 * 
 */
export class ApplicationFormApi extends runtime.BaseAPI {

    /**
     * Add a new form element to a specific subsection
     */
    async addFormElementToSubSectionRaw(requestParameters: AddFormElementToSubSectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationFormDto>> {
        if (requestParameters['applicationFormId'] == null) {
            throw new runtime.RequiredError(
                'applicationFormId',
                'Required parameter "applicationFormId" was null or undefined when calling addFormElementToSubSection().'
            );
        }

        if (requestParameters['subsectionId'] == null) {
            throw new runtime.RequiredError(
                'subsectionId',
                'Required parameter "subsectionId" was null or undefined when calling addFormElementToSubSection().'
            );
        }

        if (requestParameters['position'] == null) {
            throw new runtime.RequiredError(
                'position',
                'Required parameter "position" was null or undefined when calling addFormElementToSubSection().'
            );
        }

        if (requestParameters['formElementDto'] == null) {
            throw new runtime.RequiredError(
                'formElementDto',
                'Required parameter "formElementDto" was null or undefined when calling addFormElementToSubSection().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['position'] != null) {
            queryParameters['position'] = requestParameters['position'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-forms/{applicationFormId}/subsections/{subsectionId}/form-elements`.replace(`{${"applicationFormId"}}`, encodeURIComponent(String(requestParameters['applicationFormId']))).replace(`{${"subsectionId"}}`, encodeURIComponent(String(requestParameters['subsectionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FormElementDtoToJSON(requestParameters['formElementDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationFormDtoFromJSON(jsonValue));
    }

    /**
     * Add a new form element to a specific subsection
     */
    async addFormElementToSubSection(requestParameters: AddFormElementToSubSectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationFormDto> {
        const response = await this.addFormElementToSubSectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Archive an application form
     */
    async archiveApplicationFormRaw(requestParameters: ArchiveApplicationFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationFormDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling archiveApplicationForm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-forms/{id}/archive`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationFormDtoFromJSON(jsonValue));
    }

    /**
     * Archive an application form
     */
    async archiveApplicationForm(requestParameters: ArchiveApplicationFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationFormDto> {
        const response = await this.archiveApplicationFormRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Assign signers to a submitted application form
     */
    async assignSignersRaw(requestParameters: AssignSignersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationFormDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling assignSigners().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-forms/{id}/assign-signers`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationFormDtoFromJSON(jsonValue));
    }

    /**
     * Assign signers to a submitted application form
     */
    async assignSigners(requestParameters: AssignSignersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationFormDto> {
        const response = await this.assignSignersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new ApplicationForm
     */
    async createApplicationFormRaw(requestParameters: CreateApplicationFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationFormDto>> {
        if (requestParameters['applicationFormDto'] == null) {
            throw new runtime.RequiredError(
                'applicationFormDto',
                'Required parameter "applicationFormDto" was null or undefined when calling createApplicationForm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-forms`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApplicationFormDtoToJSON(requestParameters['applicationFormDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationFormDtoFromJSON(jsonValue));
    }

    /**
     * Create a new ApplicationForm
     */
    async createApplicationForm(requestParameters: CreateApplicationFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationFormDto> {
        const response = await this.createApplicationFormRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a ApplicationForm
     */
    async deleteApplicationFormRaw(requestParameters: DeleteApplicationFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteApplicationForm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-forms/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a ApplicationForm
     */
    async deleteApplicationForm(requestParameters: DeleteApplicationFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteApplicationFormRaw(requestParameters, initOverrides);
    }

    /**
     * Get all ApplicationForms
     */
    async getAllApplicationFormsRaw(requestParameters: GetAllApplicationFormsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedApplicationFormDto>> {
        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organizationId'] = requestParameters['organizationId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sortDirection'] = requestParameters['sortDirection'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['createdByCurrentUser'] != null) {
            queryParameters['createdByCurrentUser'] = requestParameters['createdByCurrentUser'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-forms`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedApplicationFormDtoFromJSON(jsonValue));
    }

    /**
     * Get all ApplicationForms
     */
    async getAllApplicationForms(requestParameters: GetAllApplicationFormsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedApplicationFormDto> {
        const response = await this.getAllApplicationFormsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a specific ApplicationForm
     */
    async getApplicationFormByIdRaw(requestParameters: GetApplicationFormByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationFormDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getApplicationFormById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-forms/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationFormDtoFromJSON(jsonValue));
    }

    /**
     * Get a specific ApplicationForm
     */
    async getApplicationFormById(requestParameters: GetApplicationFormByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationFormDto> {
        const response = await this.getApplicationFormByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Dry-run a template migration and return the change report
     */
    async getApplicationFormMigrationPreviewRaw(requestParameters: GetApplicationFormMigrationPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MigrationPreviewDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getApplicationFormMigrationPreview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-forms/{id}/migration-preview`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MigrationPreviewDtoFromJSON(jsonValue));
    }

    /**
     * Dry-run a template migration and return the change report
     */
    async getApplicationFormMigrationPreview(requestParameters: GetApplicationFormMigrationPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MigrationPreviewDto> {
        const response = await this.getApplicationFormMigrationPreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the template-migration status of an application form
     */
    async getApplicationFormMigrationStatusRaw(requestParameters: GetApplicationFormMigrationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MigrationStatusDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getApplicationFormMigrationStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-forms/{id}/migration-status`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MigrationStatusDtoFromJSON(jsonValue));
    }

    /**
     * Get the template-migration status of an application form
     */
    async getApplicationFormMigrationStatus(requestParameters: GetApplicationFormMigrationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MigrationStatusDto> {
        const response = await this.getApplicationFormMigrationStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Migrate a form to a newer template version
     */
    async migrateApplicationFormRaw(requestParameters: MigrateApplicationFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationFormDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling migrateApplicationForm().'
            );
        }

        if (requestParameters['migrateRequestDto'] == null) {
            throw new runtime.RequiredError(
                'migrateRequestDto',
                'Required parameter "migrateRequestDto" was null or undefined when calling migrateApplicationForm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-forms/{id}/migrate`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MigrateRequestDtoToJSON(requestParameters['migrateRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationFormDtoFromJSON(jsonValue));
    }

    /**
     * Migrate a form to a newer template version
     */
    async migrateApplicationForm(requestParameters: MigrateApplicationFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationFormDto> {
        const response = await this.migrateApplicationFormRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submit an application form
     */
    async submitApplicationFormRaw(requestParameters: SubmitApplicationFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationFormDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling submitApplicationForm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-forms/{id}/submit`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationFormDtoFromJSON(jsonValue));
    }

    /**
     * Submit an application form
     */
    async submitApplicationForm(requestParameters: SubmitApplicationFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationFormDto> {
        const response = await this.submitApplicationFormRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Restore an archived application form to draft
     */
    async unarchiveApplicationFormRaw(requestParameters: UnarchiveApplicationFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationFormDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling unarchiveApplicationForm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-forms/{id}/unarchive`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationFormDtoFromJSON(jsonValue));
    }

    /**
     * Restore an archived application form to draft
     */
    async unarchiveApplicationForm(requestParameters: UnarchiveApplicationFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationFormDto> {
        const response = await this.unarchiveApplicationFormRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a ApplicationForm
     */
    async updateApplicationFormRaw(requestParameters: UpdateApplicationFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationFormDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateApplicationForm().'
            );
        }

        if (requestParameters['applicationFormDto'] == null) {
            throw new runtime.RequiredError(
                'applicationFormDto',
                'Required parameter "applicationFormDto" was null or undefined when calling updateApplicationForm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-forms/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ApplicationFormDtoToJSON(requestParameters['applicationFormDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationFormDtoFromJSON(jsonValue));
    }

    /**
     * Updates a ApplicationForm
     */
    async updateApplicationForm(requestParameters: UpdateApplicationFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationFormDto> {
        const response = await this.updateApplicationFormRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetAllApplicationFormsSortByEnum = {
    Name: 'name',
    Status: 'status',
    CreatedAt: 'createdAt',
    ModifiedAt: 'modifiedAt',
    ReviewDate: 'reviewDate'
} as const;
export type GetAllApplicationFormsSortByEnum = typeof GetAllApplicationFormsSortByEnum[keyof typeof GetAllApplicationFormsSortByEnum];
/**
 * @export
 */
export const GetAllApplicationFormsSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAllApplicationFormsSortDirectionEnum = typeof GetAllApplicationFormsSortDirectionEnum[keyof typeof GetAllApplicationFormsSortDirectionEnum];
